const smallBannerTypes =  {
    FETCH_SMALLBANNER_START : 'FETCH_SMALLBANNER_START',
    FETCH_SMALLBANNER_SUCCESS : 'FETCH_SMALLBANNER_SUCCESS',
    FETCH_SMALLBANNER_FAILURE : 'FETCH_SMALLBANNER_FAILURE',
}

export default smallBannerTypes;